import axios from 'axios';
import { waitForTenantSwitch } from 'features/user/userActions';

/*
 * AGENT-CONTEXT: report sections mount as children of the FrontOffice route, so
 * their effects run before the parent issues the tenant/app switch. NetworkManger
 * cancels every in-flight request for the duration of that switch, which leaves
 * the sections rendering empty (e.g. every custom report falling into
 * "Uncategorized", no ad-hoc or favorite reports).
 * @invariant a cancelled request is retried exactly once, after the tenant
 * switch settles. Override only if NetworkManger stops cancelling on switch.
 */
export const requestWithTenantSwitchRetry = async (sendRequest) => {
  try {
    return await sendRequest();
  } catch (err) {
    if (!axios.isCancel(err)) {
      throw err;
    }
    await waitForTenantSwitch();
    return sendRequest();
  }
};
